/**
 * @generated SignedSource<<376d0e61c1cea2b46890dc60d34e63de>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues$data = {
  readonly progress?: number | null | undefined;
  readonly task?: {
    readonly id: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues";
};
export type exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues$key = {
  readonly " $data"?: exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues$data;
  readonly " $fragmentSpreads": FragmentRefs<"exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "concreteType": "JiraIssueExportTask",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "progress"
        }
      ],
      "type": "JiraIssueExportTaskProgress"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/)
      ],
      "type": "JiraIssueExportTaskSubmitted"
    }
  ],
  "type": "JiraIssueExportEvent",
  "abstractKey": "__isJiraIssueExportEvent"
};
})();

(node as any).hash = "371625b39b4c37b1d9efbafcef54a1e3";

export default node;
